import React from 'react';
import styled from 'styled-components';
import {IItem} from '../../Interfaces';

import {
  FaFire,
  FaBacon,
  FaCookieBite,
} from 'react-icons/fa';

import {GiFat, GiSaltShaker} from 'react-icons/gi';

import HoverInfo from '../UI/HoverInfo/HoverInfo';

const ListItem = styled.li`
  height: 100%;
  position: relative;
  color: ${({theme}) => theme.colors.fontLight};
  & > * {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
const Values = styled.p`
  padding: 0;
  margin: 10px 0;
  font-size: 0.8em;
  text-align: center;
  color: black;
`;

const NutritionsList: React.FC<{item: IItem}> = ({
  item,
}) => {
  const isNumber = (nutrition: number | string) =>
    isNaN(+nutrition) ? '-' : nutrition;
  return (
    <div>
      <ListItem>
        <HoverInfo info="Fat">
          <GiFat color='black' />
          <Values>{isNumber(item.fat)}</Values>
        </HoverInfo>
      </ListItem>
      <ListItem>
        <HoverInfo info="Carbs">
          <FaBacon  color='black'/>
          <Values>{isNumber(item.carbohydrates)}</Values>
        </HoverInfo>
      </ListItem>
      <ListItem>
        <HoverInfo info="Energy">
          <FaFire  color='black' />
          <Values>{isNumber(item.energy)}</Values>
        </HoverInfo>
      </ListItem>
      <ListItem>
        <HoverInfo info="Salt">
          <GiSaltShaker  color='black' />
          <Values>{isNumber(item.salt)}</Values>
        </HoverInfo>
      </ListItem>
      <ListItem>
        <HoverInfo info="Protein">
          <FaCookieBite  color='black'/>
          <Values>{isNumber(item.protein)}</Values>
        </HoverInfo>
      </ListItem>
    </div>
  );
};

export default NutritionsList;
